import { Snackbar } from '@interstate/components/Snackbar';
import { useBalloonPaymentField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const BalloonPaymentRow = () => {
    const { label, inputProps, fallbackSnackbarProps } = useBalloonPaymentField();
    const inputId = useScenarioCellId('balloonPayment');

    return (
        <ScenarioRow rowKey="balloonPayment" label={label} inputId={inputId}>
            <NumericInput {...inputProps} id={inputId} displayLabel={false} />
            <Snackbar {...fallbackSnackbarProps} />
        </ScenarioRow>
    );
};
